import { render } from "./LogisticTableLogist.vue?vue&type=template&id=53846f44"
import script from "./LogisticTableLogist.vue?vue&type=script&lang=js"
export * from "./LogisticTableLogist.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__